import { render } from "./BtnDocumentIcon.vue?vue&type=template&id=f01664a4"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/BtnDocumentIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f01664a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f01664a4', __exports__)) {
    api.reload('f01664a4', __exports__)
  }
  
  module.hot.accept("./BtnDocumentIcon.vue?vue&type=template&id=f01664a4", () => {
    api.rerender('f01664a4', render)
  })

}


export default __exports__